export default __webpack_public_path__ + "static/media/fig-06-generated-shear-log.6e75ed36.png";